
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[groupId]",
      function () {
        return require("private-next-pages/groups/[groupId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/[groupId]"])
      });
    }
  